import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import classNames from "classnames";

export type ProductDetailsProps = {
  unitPricePerLetter: string;
  quantity: string;
};

export const ProductDetails = ({ unitPricePerLetter, quantity }: ProductDetailsProps) => {
  const { t } = useTranslation();

  return (
    <div data-testid="product-details">
      <span className={classNames("font-semibold", "text-base", "text-text-base-primary")}>
        {t("sites.letters.letter_summary")}
      </span>
      <div className={classNames("mt-4", "flex", "justify-between")}>
        <div className={classNames("flex", "font-medium")}>
          <span className="text-text-base-secondary">{quantity}x</span>

          <span className={classNames("ml-2", "text-text-base-primary")}>{t("sites.letters.standard_letter")}</span>
        </div>
        <span className={classNames("flex", "text-text-base-primary")}>{unitPricePerLetter}</span>
      </div>
    </div>
  );
};
